// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { CardListStyles } from "@insite/content-library/Components/CardList";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import Img, { ImgProps } from "@store/MobiusOverrides/Img/Img";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";

import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import loadShipments from "@store/Framework/Store/Greif/Data/Shipments/Handlers/LoadShipments";
import { getShipmentsDataView } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import LinkTo from "@store/Library/Components/LinkTo";
import StatusBadge from "@store/Library/Components/StatusBadge";
import { shipmentStatusColorMap } from "@store/Library/Components/statusColorMaps";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import { OrderSummaryCardStyles } from "@store/Overrides/Components/OrderSummaryCard";
import { tableProps } from "@store/Themes/common/props/table";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as cssLinter from "css";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    numberOfRecords = "numberOfRecords",
    customCSS = "customCSS",
    showOrderNumber = "showOrderNumber",
    showStatus = "showStatus",
    showPONumber = "showPONumber",
    showDeliveryDate = "showDeliveryDate",
    showLocation = "showLocation",
    titleImage = "titleImage",
    imageUrl = "imageUrl",
    showHeader = "showHeader",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
        [fields.customCSS]: string;
        [fields.showOrderNumber]: boolean;
        [fields.showStatus]: boolean;
        [fields.showPONumber]: boolean;
        [fields.showDeliveryDate]: boolean;
        [fields.showLocation]: boolean;
        [fields.imageUrl]: string;
        [fields.showHeader]: boolean;
    };
    persistentDataView: ReturnType<typeof getOrdersDataView>;
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    return {
        shipmentDataView: getShipmentsDataView(state, recentShipmentParameter),
        orderHistoryPageLink: getPageLinkByPageType(state, "OrderHistoryPage"),
        shipmentHistoryPageLink: getPageLinkByPageType(state, "ShipmentHistoryPage"),
        settingsCollection: getSettingsCollection(state),
        canViewOrders: isAuthenticated && (session.userRoles || "").indexOf("Requisitioner") === -1,
        showPoNumber: getSettingsCollection(state).orderSettings.showPoNumber,
        isVmiOrderHistoryPage: state.pages.orderHistory.isVmiOrderHistoryPage,
        shipToState: getShipToState(state, session.shipToId),
    };
};

const mapDispatchToProps = {
    loadShipments,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
const StyledDiv = getStyledWrapper("div");

export interface RecentShipmentStyles {
    cardList?: CardListStyles;
    errorGridItem?: GridItemProps;
    errorText?: TypographyPresentationProps;
    noOrdersFoundGridItem?: GridItemProps;
    noOrdersFoundText?: TypographyPresentationProps;
    cardContainer?: CardContainerStyles;
    orderSummaryCard?: OrderSummaryCardStyles;
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    orderNumberHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    reorderHeader?: DataTableHeaderProps;
    titleImg?: ImgProps;
    titleWrapper?: InjectableCss;
    titleStyle?: TypographyPresentationProps;
    linkWrapper?: InjectableCss;
    linkStyle?: LinkPresentationProps;
    shipmentTightCells?: DataTableCellProps;
    shipmentNumberCells?: DataTableCellProps;
    shipmentNumberLink?: LinkPresentationProps;
    shipmentTightHeader?: DataTableHeaderProps;
    tooltip?: TooltipPresentationProps;
    headingActionWrap?: InjectableCss;
    linkImg?: ImgProps;
}

export const recentShipmentStyles: RecentShipmentStyles = {
    loadingOverlay: tableProps.loadingOverlay,
    tableWrapper: tableProps.wrapper,
    noOrdersFoundText: typographyGetNoResultsProps(),
    dataTable: tableProps.dataTable,
    orderTotalHeader: tableProps.amountHeader,
    reorderHeader: tableProps.tightHeader,
    tooltip: {
        iconProps: {
            size: 16,
        },
    },
    headingActionWrap: {
        css: css`
            display: flex;
            gap: ${pxToRem(10)};
            align-items: center;
        `,
    },
    linkImg: {
        css: css`
            width: 100%;
            max-width: ${pxToRem(50)};
            height: auto;
        `,
    },
};

const defaultCustomCss = `.card-list-heading{
}

.view-all-link{
}

.no-orders-found-text{
}`;

const recentShipmentParameter: GetShipmentsApiParameter = {
    page: 1,
    sort: "deliveryDate ASC",
    deliveryStatuses: ["Undelivered"],
};

const styles = recentShipmentStyles;

const RecentShipment: React.FC<Props> = ({
    shipmentDataView,
    shipmentHistoryPageLink,
    orderHistoryPageLink,
    canViewOrders,
    fields,
    loadShipments,
    shipToState,
}) => {
    if (!canViewOrders) {
        return null;
    }

    const shipmentHistoryUrl = shipmentHistoryPageLink ? shipmentHistoryPageLink.url : undefined;

    const customCssWrapper = css`
        ${styles.wrapper?.css}
        ${fields.customCSS}
    `;

    React.useEffect(() => {
        recentShipmentParameter.pageSize = fields.numberOfRecords;
        recentShipmentParameter.customerSequence = shipToState.value?.customerSequence;
        if (canViewOrders && !shipmentDataView.value && shipToState.value) {
            loadShipments(recentShipmentParameter);
        }
    }, [shipToState.value?.customerSequence]);

    const hasNoResults = !shipmentDataView.value || shipmentDataView.value.length === 0;

    const {
        showOrderNumber = true,
        showStatus = true,
        showPONumber = true,
        showLocation = true,
        imageUrl,
        showHeader = false,
    } = fields;
    const showDeliveryDateDisplay =
        (fields.showDeliveryDate && shipmentDataView.value?.some(x => x.deliveryDateDisplay)) ?? true;

    const sortedShipments = shipmentDataView.value?.slice().sort(function (a, b) {
        return new Date(a.deliveryDate).getTime() - new Date(b.deliveryDate).getTime();
    });

    const titleComponent = React.useMemo(
        () => (
            <StyledDiv {...styles.headingActionWrap}>
                {imageUrl && <Img src={imageUrl} altText="recent shipment icon" loading="lazy" {...styles.linkImg} />}
                <Typography>{translate("Upcoming Shipments")}</Typography>
            </StyledDiv>
        ),
        [],
    );

    return (
        <StyledWrapper
            as="nav" /* Store Custom Code */
            {...styles.wrapper}
            css={customCssWrapper}
            data-test-selector="widget_RecentOrders"
        >
            {showHeader && (
                <CardListHeading
                    viewAllUrl={shipmentHistoryUrl}
                    hasNoResults={hasNoResults}
                    viewAllText={translate("View All Shipments")}
                    heading={titleComponent}
                />
            )}
            <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={shipmentDataView}>
                {hasNoResults ? (
                    <Typography
                        className="no-orders-found-text"
                        {...styles.noOrdersFoundText}
                        data-test-selector="recentOrders_NoOrdersFound"
                    >
                        {translate("No shipments found")}
                    </Typography>
                ) : (
                    <StyledWrapper {...styles.tableWrapper}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead>
                                {showOrderNumber && (
                                    <DataTableHeader {...styles.shipmentTightHeader} title={translate("Order Number")}>
                                        {translate("Greif Order #", "webOrderNumber")}
                                    </DataTableHeader>
                                )}
                                {showPONumber && fields.showPONumber && (
                                    <DataTableHeader
                                        {...styles.customerPOHeader}
                                        title={translate("Purchase Order Number")}
                                    >
                                        {translate("PO #", "customerPO")}
                                    </DataTableHeader>
                                )}
                                {showDeliveryDateDisplay && (
                                    <DataTableHeader {...styles.dateHeader}>
                                        {translate("Delivery Date", "requestedDeliveryDate")}
                                    </DataTableHeader>
                                )}
                                {showStatus && (
                                    <DataTableHeader {...styles.shipmentTightHeader}>
                                        {translate("Delivery Status", "status")}
                                    </DataTableHeader>
                                )}
                                {showLocation && (
                                    <DataTableHeader {...styles.shipmentTightHeader}>
                                        {translate("Greif Location - Recent Shipments")}
                                    </DataTableHeader>
                                )}
                            </DataTableHead>
                            <DataTableBody>
                                {sortedShipments?.map(
                                    shipment =>
                                        shipment !== null && (
                                            <DataTableRow key={shipment.id}>
                                                {showOrderNumber && (
                                                    <DataTableCell
                                                        {...styles.shipmentNumberCells}
                                                        data-test-selector="shipmentHistoryTable_tableCell_poNumber"
                                                    >
                                                        <LinkTo
                                                            {...styles.shipmentNumberLink}
                                                            title={shipment.greifOrderNumberDisplay}
                                                            pageLink={orderHistoryPageLink}
                                                            pageIdSegment={`/Details?orderNumber=${shipment.greifOrderNumber}`}
                                                        />
                                                    </DataTableCell>
                                                )}
                                                {showPONumber && fields.showPONumber && (
                                                    <DataTableCell
                                                        {...styles.shipmentNumberCells}
                                                        data-test-selector="shipmentHistoryTable_tableCell_poNumber"
                                                    >
                                                        <LinkTo
                                                            {...styles.shipmentNumberLink}
                                                            title={shipment.purchaseOrderNumber}
                                                            pageLink={shipmentHistoryPageLink}
                                                            pageIdSegment={`?customerSequence=-1&purchaseOrderNumber=${shipment.purchaseOrderNumber}`}
                                                        />
                                                    </DataTableCell>
                                                )}
                                                {showDeliveryDateDisplay && (
                                                    <DataTableCell
                                                        {...styles.shipmentTightCells}
                                                        data-test-selector="shipmentHistoryTable_tableCell_deliveryDate"
                                                    >
                                                        <Typography>{shipment.deliveryDateDisplay}</Typography>
                                                    </DataTableCell>
                                                )}

                                                {showStatus && (
                                                    <DataTableCell
                                                        {...styles.shipmentTightCells}
                                                        data-test-selector="shipmentHistoryTable_tableCell_deliveryStatus"
                                                    >
                                                        <StatusBadge
                                                            status={shipment.deliveryStatus}
                                                            displayText={
                                                                shipment.deliveryStatusDisplay ||
                                                                shipment.deliveryStatus
                                                            }
                                                            colorMap={shipmentStatusColorMap}
                                                        />
                                                    </DataTableCell>
                                                )}
                                                {showLocation && (
                                                    <DataTableCell
                                                        {...styles.shipmentTightCells}
                                                        data-test-selector="shipmentHistoryTable_tableCell_location"
                                                    >
                                                        {shipment.locationDescription}
                                                    </DataTableCell>
                                                )}
                                            </DataTableRow>
                                        ),
                                )}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                )}
            </DataViewLoadingOverlay>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RecentShipment),
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Recent Orders Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 5,
                fieldType: "General",
                sortOrder: 1,
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            {
                name: fields.showOrderNumber,
                displayName: "Order #",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => false,
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: fields.showStatus,
                displayName: "Status",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showPONumber,
                displayName: "PO #",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showDeliveryDate,
                displayName: "Requested Delivery Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 7,
            },
            {
                name: fields.showLocation,
                displayName: "Location",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 7,
            },
            {
                name: fields.imageUrl,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.showHeader,
                displayName: "Show Header and View All Link",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 9,
            },
        ],
    },
};

export default widgetModule;
